import { render, staticRenderFns } from "./PortalLinea.vue?vue&type=template&id=0f524ec8&scoped=true"
import script from "./PortalLinea.vue?vue&type=script&lang=js"
export * from "./PortalLinea.vue?vue&type=script&lang=js"
import style0 from "./PortalLinea.vue?vue&type=style&index=0&id=0f524ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f524ec8",
  null
  
)

export default component.exports